import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import { InputWrapper, SectionTitle, Text } from "areas/order/components"
import FloatInput from "components/ui/float-input"

const ContactInformation = ({ control }) => (
  <Box flex="1" mb={2}>
    <SectionTitle>Contact Information</SectionTitle>
    <Text mb={2}>Please enter your contact information below:</Text>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_name"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            autoComplete="name"
            error={error}
            id="contact_name"
            label="Full name"
            placeholder="Full name"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_email"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            autoComplete="email"
            error={error}
            id="contact_email"
            label="Email Address"
            placeholder="Email Address"
            type="email"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
    <InputWrapper>
      <Controller
        control={control}
        name="contact_phone_num"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            autoComplete="tel"
            error={error}
            id="contact_phone_num"
            label="Phone number"
            placeholder="Phone number"
            variant="checkout"
            {...field}
          />
        )}
      />
    </InputWrapper>
  </Box>
)

ContactInformation.propTypes = {
  control: PropTypes.object,
}

export default ContactInformation
